import urlAliasService from './url-alias';
import urlPatternService from './url-pattern';
import bulkGenerateService from './bulk-generate';
import getMainFieldService from './get-main-field';

export default {
  'url-alias': urlAliasService,
  'url-pattern': urlPatternService,
  'bulk-generate': bulkGenerateService,
  'get-main-field': getMainFieldService,
};
